import * as angular from 'angular';
import * as _ from 'lodash';

import { ComponentDefinition, Identifier, Group, ConstraintResult, IdentifierType } from '../../../models/index';
import { IGroupService, ILoggerService } from '../../../services';

class ReconciliationEquationTableController implements angular.IComponentController {

    form: angular.IFormController;
    // item: Widgets.ReconciliationEquationTableWidget;
    isLoading: boolean;
    identifiers: Identifier[];
    displayed: Identifier[];
    group: Group;
    results: ConstraintResult[];

    static $inject = ['$scope', '$q', 'groupService', 'loggerService'];

    constructor(private $scope: angular.IScope,
        private $q: angular.IQService,
        private groupService: IGroupService,
        private loggerService: ILoggerService) {
    }

    $onInit() {
        this.$scope.$watch(() => this.identifiers, (newValue) => {
            if (newValue) {
                this.displayed = this.identifiers.filter(i => i.type === IdentifierType.CalculatedValue);
                this.assignReconciledValue();
            }
        }, true);

        this.$scope.$watch(() => this.results, (newValue) => {
            if (newValue) {
                this.assignReconciledValue();
            }
        }, true);
    }

    private assignReconciledValue() {
        this.displayed.forEach(i => {
            (<any>i).reconcile = _.find(this.results, r => i.guid === r.identifierGuid);
        });
    }

    save() {
        this.isLoading = true;
        const defered = this.$q.defer();
        this.groupService
            .updateIdentifiers(this.group.guid, this.displayed)
            .then(data => {
                this.loggerService.logSuccess('Identifiers updated');
                this.form.$setPristine();
                defered.resolve();
            })
            .catch(() => {
                defered.reject('Failed to save tags');
            })
            .finally(() => {
                this.isLoading = false;
            });

        return defered.promise;
    }
}

export const wtReconciliationEquationTable: ComponentDefinition = {
    componentId: 'wtReconciliationEquationTable',
    controller: ReconciliationEquationTableController,
    template: require('./reconciliationEquationTable.component.html'),
    controllerAs: 'vm',
    bindings: {
        item: '=',
        identifiers: '=',
        group: '=',
        form: '=',
        results: '='
    }
};
